import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function StartOrderDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >   
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {"Start Order(s): "}
            </DialogTitle>
            <DialogContent>
                <DialogContentText className={classes.dialogContext}>
                    <ul>
                    {props.orderList.map(x => <li>{x}</li>)}
                    </ul>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} autoFocus onClick={props.closeDialog} >
                        {t("CANCEL")}
                    </Button>
                    <Button className={classes.startButton} autoFocus onClick={props.action(true)} >
                        {t("START")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    cancelButton: {
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        margin: "3px",
        width: "100px",
        marginBottom: "20px"

    },
    startButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        background: FlagstoneTheme.palette.lightGreen.main,
        '&:hover': {
            background: FlagstoneTheme.palette.lightGreen.main,
        },
        margin: "3px",
        width: "100px",
        marginBottom: "20px"
    },

    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        cursor: 'move',
        marginTop:"20px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
       // textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    }
}));
